"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveLogo = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var _DomestikaLive = require("./DomestikaLive");

function blinkingEffect() {
  return (0, _styledComponents.keyframes)(["50%{opacity:0;}"]);
}

var StyledDomestikaLiveLogoContainer = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "DomestikaLiveLogo__StyledDomestikaLiveLogoContainer",
  componentId: "tt333w-0"
})((0, _css.default)({
  display: 'inline-block',
  position: 'relative',
  width: 'auto'
}));
var StyledDomestikaLiveLogo = (0, _styledComponents.default)(StyledDomestikaLiveLogoContainer).withConfig({
  displayName: "DomestikaLiveLogo__StyledDomestikaLiveLogo",
  componentId: "tt333w-1"
})(["&::after{display:block;position:absolute;top:9px;right:0;width:7px;height:7px;background:#f02d00;animation:", " 1s steps(1,end) infinite;content:'';border-radius:100%;@media (min-width:768px){top:12px;right:0;width:9px;height:9px;}}"], blinkingEffect);

var DomestikaLiveLogo = function DomestikaLiveLogo(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return _react.default.createElement(StyledDomestikaLiveLogo, null, _react.default.createElement(_DomestikaLive.DomestikaLive, {
    width: width,
    height: height
  }));
};

exports.DomestikaLiveLogo = DomestikaLiveLogo;
DomestikaLiveLogo.defaultProps = {
  width: ['176px', '223px', '223px'],
  height: ['26px', '33px', '33px']
};